import AssetField from '../../../contentful/AssetField';
import {NavLink as Link} from 'react-router-dom';
import update from 'immutability-helper';
import React from 'react';
import _ from 'lodash';
import PublishStatusDot from '../../../misc/PublishStatusDot.js';

class DealerEmployeeEdit extends React.Component {
  constructor(props) {
    super(props);

    this.checkEmployeeType = this.checkEmployeeType.bind(this);
    this.checkMakesBlacklist = this.checkMakesBlacklist.bind(this);
    this.handleAssetChange = this.handleAssetChange.bind(this);
    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.handlePublish = this.handlePublish.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleTypeChange = this.handleTypeChange.bind(this);
    this.handleMakesBlacklistChange = this.handleMakesBlacklistChange.bind(this);
    this.handleUnpublish = this.handleUnpublish.bind(this);
  }

  handleSubmit(e) {
    e.preventDefault();
    this.props.onSave();
  }

  handlePublish(e) {
    e.preventDefault();
    this.props.onPublish();
  }

  handleUnpublish(e) {
    e.preventDefault();
    this.props.onUnpublish();
  }

  handleSave(e) {
    e.preventDefault();
    this.props.onSave();
  }

  handleAssetChange(name, asset) {
    const change = {
      employee: {}
    };

    change.employee[name] = {
      $set: asset
    };

    const props = update(this.props, change);

    this.props.onChange(props);
  }

  handleFieldChange(e) {
    if (e.target.type === 'checkbox') {
      e.target.value = e.target.checked;
    }
    const newData = {
      employee: {}
    };

    newData.employee[e.target.name] = {
      $set: e.target.value
    };

    const props = update(this.props, newData);

    this.props.onChange(props);
  }

  handleTypeChange() {
    const types = [];
    const inputs = document.getElementsByClassName('employeeType');

    _.forEach(inputs, function (input) {
      if (input.checked) {
        types.push(input.value);
      }
    });

    const newObj = {
      target: {
        name: 'type',
        value: types
      }
    };
    this.handleFieldChange(newObj);
  }

  checkEmployeeType(type) {
    let ret = false;
    if (this.props.employee.type && type) {
      _.forEach(this.props.employee.type, function (value) {
        if (String(value) === String(type)) {
          ret = true;
        }
      });
    }
    return ret;
  }

  handleMakesBlacklistChange(event) {
    // console.log(event);
    // Disable change while updating
    const inputs = document.getElementsByClassName('blacklist');
    this.handleCheckboxState(inputs, 'disable');

    const blacklist = this.props.employee.makesBlacklist;
    const id = event.target.getAttribute('value');

    // Handle checkbox events
    if (event.target.checked === true) {
      // Checkbox is checked
      // add to blacklist
      blacklist.push(id);
    } else {
      // Checkbox is unchecked
      // Remove from blacklist
      const index = blacklist.indexOf(id);
      if (index > -1) {
        blacklist.splice(index, 1);
      }
    }
    const newObj = {
      target: {
        name: 'makesBlacklist',
        value: blacklist
      }
    };
    this.handleFieldChange(newObj);
    this.handleCheckboxState(inputs, 'enable');
  }

  checkMakesBlacklist(make) {
    let ret = false;
    if (this.props.employee.makesBlacklist && make) {
      _.forEach(this.props.employee.makesBlacklist, function (value) {
        if (String(value) === String(make)) {
          ret = true;
        }
      });
    }
    return ret;
  }

  handleCheckboxState(inputs, newState) {
    if (newState === 'enable') {
      _.forEach(inputs, function (input) {
        input.disabled = false;
      });
    } else {
      _.forEach(inputs, function (input) {
        input.disabled = true;
      });
    }
  }

  render() {
    const employee = this.props.employee;
    const makes = this.props.makes;

    const makesList = (
      makes.map((make, i) => {
        if (make.isInternal) {
          return (
            <div className="checkbox" key={i}>
              <label>
                <input type="checkbox" className="blacklist" name="blacklist" value={make.id} defaultChecked={this.checkMakesBlacklist(make.id)} onChange={this.handleMakesBlacklistChange} disabled={this.props.working} />
                {make.name}
              </label>
            </div>
          );
        }
        return null;
      })
    );

    const predefinedTags = ['Ansatt'];
    if (employee.dealer?.name) {
      predefinedTags.push(employee.dealer.name);
    }

    return (
      <section className="mg-employee-edit">
        <ol className="breadcrumb mf-margin-top-20">
          <li><Link to="/">Forsiden</Link></li>
          <li><Link to="/forhandlere/">Forhandlere</Link></li>
          <li><Link to={`/forhandler/${employee.dealer?.id || this.props.dealerId}`}>{employee.dealer?.name || 'Ny ansatt'}</Link></li>
          <li className="active">{employee.name}</li>
        </ol>

        <form onSubmit={this.handleSubmit}>
          <div className="page-header">
            <div className="pull-right">
              {this.props.working &&
                <span><i className="fa fa-spinner fa-pulse fa-fw"></i> Arbeider...&nbsp;</span>
              }
              <button
                type="submit"
                className="btn btn-default"
                disabled={!this.props.modified || this.props.working}
              >
                <span>{!employee.id ? 'Opprett ansatt' : 'Lagre endringer'}</span>
              </button>
              &nbsp;
              <button
                type="button"
                className="btn btn-success"
                disabled={(employee.published && !employee.updated) || this.props.working || this.props.modified}
                onClick={this.handlePublish}
              >
                <span>Publiser</span>
              </button>
              &nbsp;
              <button
                type="button"
                className="btn btn-warning"
                disabled={!employee.id || employee.draft || this.props.working}
                onClick={this.handleUnpublish}
              >
                <span>Avpubliser</span>
              </button>
            </div>

            <h1>
              {employee.name} <PublishStatusDot entry={employee} /><br />
              <small>Ansatt</small>
            </h1>
          </div>

          {/* Display any error message: */}
          {this.props.error &&
            <div className="alert alert-danger">
              {this.props.error}
            </div>
          }

          <div className="row">
            <div className="col-xs-12 col-md-6">
              {/* Data */}
              <div className="form-group">
                <label>Navn</label>
                <div className="input-group">
                  <input type="text" className="form-control" name="name" defaultValue={employee.name} disabled />
                  {/*<input type="text" className="form-control" name="name" defaultValue={employee.name} disabled={this.props.working} onChange={this.handleFieldChange}/>*/}
                  <div className="input-group-addon">Data fra AD</div>
                </div>
              </div>

              <div className="form-group">
                <label>Stilling</label>
                <div className="input-group">
                  <input type="text" className="form-control" name="position" defaultValue={employee.position} disabled />
                  {/*<input type="text" className="form-control" name="position" defaultValue={employee.position} disabled={this.props.working} onChange={this.handleFieldChange}/>*/}
                  <div className="input-group-addon">Data fra AD</div>
                </div>
              </div>

              <div className="form-group">
                <label>Telefon</label>
                <div className="input-group">
                  <input type="text" className="form-control" name="phone" defaultValue={employee.phone} disabled />
                  {/*<input type="text" className="form-control" name="phone" defaultValue={employee.phone} disabled={this.props.working} onChange={this.handleFieldChange}/>*/}
                  <div className="input-group-addon">Data fra AD</div>
                </div>
              </div>

              <div className="form-group">
                <label>Telefon overstyring</label>
                <input type="text" className="form-control" name="phoneOverride" defaultValue={employee.phoneOverride} disabled={this.props.working} onChange={this.handleFieldChange}/>
                <span id="helpBlock" className="help-block">Overstyrer telefon. Brukes dersom telefon er korrekt men det ønskes å vise et annet nummer på nettsiden.</span>
              </div>

              <div className="form-group">
                <label>E-post</label>
                <div className="input-group">
                  <input type="email" className="form-control" name="email" defaultValue={employee.email} disabled />
                  {/*<input type="email" className="form-control" name="email" defaultValue={employee.email} disabled={this.props.working} onChange={this.handleFieldChange}/>*/}
                  <div className="input-group-addon">Data fra AD</div>
                </div>
              </div>

              <div className="form-group">
                <label>E-post overstyring</label>
                <input type="text" className="form-control" name="emailOverride" defaultValue={employee.emailOverride} disabled={this.props.working} onChange={this.handleFieldChange}/>
                <span id="helpBlock" className="help-block">Overstyrer e-post. Brukes dersom e-post er korrekt men det ønskes å vise en annen e-post på nettsiden.</span>
              </div>

              <div className="row">
                <div className="col-xs-12">
                  <div className="form-group">
                    <label>Synlighet</label>
                    {/* <div className="checkbox">
                      <label>
                        <input type="checkbox" name="visibleAsSalesperson" defaultChecked={employee.visibleAsSalesperson} onChange={this.handleFieldChange} disabled={this.props.working} />
                        Synlig som salgsperson
                      </label>
                    </div>*/}
                    <div className="checkbox">
                      <label>
                        <input type="checkbox" name="visibleOnWeb" defaultChecked={employee.visibleOnWeb} onChange={this.handleFieldChange} disabled={this.props.working} />
                        Synlig på web
                      </label>
                    </div>
                    <div className="checkbox">
                      <label>
                        <input type="checkbox" name="hideContactInfo" defaultChecked={employee.hideContactInfo} onChange={this.handleFieldChange} disabled={this.props.working} />
                        Skjul kontaktinfo
                      </label>
                    </div>
                  </div>
                </div>

                <div className="col-xs-12 col-sm-4">
                  <div className="form-group">
                    <label>Roller <small>(Data fra AD)</small></label>
                    {employee.roles &&
                      <ul>
                        {employee.roles.map((role, i) => <li key={i}>{role}</li>)}
                      </ul>
                    }
                  </div>
                </div>
                <div className="col-xs-12 col-sm-4">
                  <div className="form-group">
                    <label>Ansattype</label>
                    <div className="checkbox">
                      <label>
                        <input type="checkbox" className="employeeType" name="type_adviser" value="adviser" defaultChecked={this.checkEmployeeType('adviser')} onChange={this.handleTypeChange} disabled={this.props.working} />
                        Kunderådgiver verksted
                      </label>
                    </div>
                    <div className="checkbox">
                      <label>
                        <input type="checkbox" className="employeeType" name="type_sale" value="sale" defaultChecked={this.checkEmployeeType('sale')} onChange={this.handleTypeChange} disabled={this.props.working} />
                        Salg nybil
                      </label>
                    </div>
                    <div className="checkbox">
                      <label>
                        <input type="checkbox" className="employeeType" name="type_parts" value="parts" defaultChecked={this.checkEmployeeType('parts')} onChange={this.handleTypeChange} disabled={this.props.working} />
                        Delesalg
                      </label>
                    </div>
                  </div>
                </div>

                <div className="col-xs-12 col-sm-4">
                  <div className="form-group">
                    <label>Utelat fra</label>
                    {makesList}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-xs-12 col-md-6">
              {/* Image */}
              <div className="form-group">
                <label>Bilde</label>
                <AssetField name="image" value={employee.image} onChange={this.handleAssetChange} disabled={this.props.working} predefinedTags={predefinedTags} />
              </div>
            </div>
          </div>
        </form>
      </section>
    );
  }
}

export default DealerEmployeeEdit;
